import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updatelivedata } from '../../../../store/mainpage_data';
import { livedata } from '../../../../Restclient/datacollection';

/**
 * Triggers a one-shot /livedata fetch when the DT dashboard panel mounts so
 * widgets can render fresh values immediately instead of waiting up to 60s
 * for the next tick of the global poll started by Mainheader.
 *
 * The recurring poll is intentionally NOT started here — Mainheader already
 * runs a 60s interval that dispatches into the same Redux slice. Adding a
 * second interval would double the request rate while the panel is open.
 */
export function useDTLiveData() {
  const dispatch = useDispatch();

  useEffect(() => {
    livedata((res) => {
      try {
        dispatch(updatelivedata(JSON.parse(res.data.data)));
      } catch (_) {}
    });
  }, [dispatch]);
}
